export default __webpack_public_path__ + "static/media/img_hr.a143e14c.png";